import { render } from "./FullContactForm.vue?vue&type=template&id=1404d8e1"
import script from "./FullContactForm.vue?vue&type=script&lang=js"
export * from "./FullContactForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__